<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { Swiper } from 'swiper/vue';

import 'swiper/css';

import { defaultSwiperOptions } from '~/components/ui/UiSlider/constants/option';
import { isMobile } from '~/utils/isMobile';

defineEmits(['slideChange']);

const props = defineProps({
    swiperOptions: {
        type: Object,
        default: () => ({}),
    },
    initOnlyOnMobile: {
        type: Boolean,
        default: false,
    },
});

const computedSwiperOptions = computed(() => {
    if (Object.keys(props.swiperOptions).length === 0) {
        return defaultSwiperOptions;
    }

    return {
        ...defaultSwiperOptions,
        ...props.swiperOptions,
    };
});

const isSwiperActive = ref(!props.initOnlyOnMobile);

const updateSwiperStatus = () => {
    isSwiperActive.value = isMobile();
};

if (props.initOnlyOnMobile) {
    onMounted(() => {
        updateSwiperStatus();
        window.addEventListener('resize', updateSwiperStatus);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', updateSwiperStatus);
    });
}
</script>

<template>
    <Swiper
        v-if="isSwiperActive"
        v-bind="computedSwiperOptions"
        class="swiper"
        @slideChange="$emit('slideChange', $event)"
    >
        <slot />
    </Swiper>

    <div v-else>
        <slot />
    </div>
</template>
